import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const Services = () => {
  return (
    <div className="py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="space-y-12">
          <div className="w-full flex justify-center mb-8">
            <img 
              src="/lovable-uploads/3478f13f-675b-4d23-b635-3bab72926c78.png"
              alt="Happy people enjoying financial freedom"
              className="rounded-xl shadow-lg w-full max-w-2xl h-[400px] object-cover object-top"
            />
          </div>

          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-center text-white">
              Break Free from Debt & Start Living Again
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed">
              Are you overwhelmed by debt? You're not alone. Every day, countless South Africans grapple with the stress of financial obligations they cannot meet, unexpected bills, and the constant anxiety of falling behind.
            </p>
            <p className="text-gray-300 text-lg leading-relaxed">
              The good news? There is a solution. It's not only effective but also tailored specifically for South Africans like you. This approach provides immediate relief from debt while safeguarding your hard-earned assets and savings.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm">
              <h3 className="text-xl font-semibold text-white">Why Debt Feels Like a Trap</h3>
              <p className="text-gray-300">
                Debt often starts small but can snowball due to high interest rates, unforeseen expenses, or sudden changes in your financial situation. For many South Africans, trying to manage their debt becomes a relentless cycle of minimum payments and growing balances.
              </p>
            </div>
            <div className="space-y-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm">
              <h3 className="text-xl font-semibold text-white">Our Commitment</h3>
              <p className="text-gray-300">
                At Tradeco, helping you is our first priority. Unlike traditional debt solutions that often leave you feeling stuck or overwhelmed, we focus on protecting your assets, reducing your debt, and providing peace of mind.
              </p>
            </div>
          </div>

          <div className="text-center space-y-6">
            <h3 className="text-2xl font-bold text-white">Ready to Transform Your Financial Future?</h3>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild size="lg" className="bg-primary hover:bg-primary/90">
                <Link to="/register">
                  Start Your Journey Today
                </Link>
              </Button>
              <Button asChild size="lg" variant="secondary">
                <Link to="/login">
                  Login to Your Account
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-white/20 text-black">
                <Link to="/calculator">
                  Calculate Your Savings
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};